import * as XLSX from "xlsx";
import { SyncOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Typography,
  Input,
  Button,
  Space,
  Form,
  Table,
  Flex,
} from "antd";
import { useEffect, useState } from "react";
import "../Pages/CSS/Traitement.css";
import moment from "moment";
import { SuspensionsService } from "../Services/SuspensionsService";



const SuspensionsOpt = () => {
  const initialTableData = [];
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const [totalMontdoc, setTotalMontdoc] = useState(0);
  const [totalTicket, setTotalTicket] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [form] = Form.useForm();

  const suspensionsService = new SuspensionsService();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await suspensionsService.getSuspensionsOpt();
        setTableData(data);
        setFilteredData(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const totalMontdoc = filteredData.reduce(
      (acc, curr) => acc + parseFloat(curr.montdoc || 0),
      0
    );
    const totalTicket = filteredData.reduce(
      (acc, curr) => acc + parseFloat(curr.ticket || 0),
      0
    );

    setTotalMontdoc(totalMontdoc);
    setTotalTicket(totalTicket);
  }, [filteredData]);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const exportToExcel = (data, fileName = "export.xlsx") => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);
  };



  const columns = [
    {
      title: 'Matricule',
      dataIndex: 'numcont',
      key: 'numcont',
      align: "center",
      sorter: (a, b) => {
        if (!a.numcont && b.numcont) return 1;
        if (a.numcont && !b.numcont) return -1;
        if (!a.numcont && !b.numcont) return 0;
        return a.numcont.localeCompare(b.numcont);
      },
    },
    {
      title: 'Participant',
      dataIndex: 'part',
      key: 'part',
      sorter: (a, b) => {
        if (!a.part && b.part) return 1;
        if (a.part && !b.part) return -1;
        if (!a.part && !b.part) return 0;
        return a.part.localeCompare(b.part);
      },
    },
    //matribenef
    {
      title: 'Matricule bénéficiaire',
      dataIndex: 'matribenef',
      key: 'matribenef',
      align: "center",
      sorter: (a, b) => {
        if (!a.matribenef && b.matribenef) return 1;
        if (a.matribenef && !b.matribenef) return -1;
        if (!a.matribenef && !b.matribenef) return 0;
        return a.matribenef.localeCompare(b.matribenef);
      },
    },
    {
      title: 'Bénéficiaire',
      dataIndex: 'benef',
      key: 'benef',
      sorter: (a, b) => {
        if (!a.benef && b.benef) return 1;
        if (a.benef && !b.benef) return -1;
        if (!a.benef && !b.benef) return 0;
        return a.benef.localeCompare(b.benef);
      },
    },
    {
      title: 'Sexe',
      dataIndex: 'sexe',
      key: 'sexe',
      align: "center",
      sorter: (a, b) => {
        if (!a.sexe && b.sexe) return 1;
        if (a.sexe && !b.sexe) return -1;
        if (!a.sexe && !b.sexe) return 0;
        return a.sexe.localeCompare(b.sexe);
      },
    },
 
    {
      title: 'Société',
      dataIndex: 'societe',
      key: 'societe',
      sorter: (a, b) => {
        if (!a.societe && b.societe) return 1;
        if (a.societe && !b.societe) return -1;
        if (!a.societe && !b.societe) return 0;
        return a.societe.localeCompare(b.societe);
      },
    },
    {
      title: 'Âge',
      dataIndex: 'agepart',
      key: 'agepart',
      align: "center",
      sorter: (a, b) => (a.agepart ?? 0) - (b.agepart ?? 0),
    },
   
    {
      title: 'N° Bon',
      dataIndex: 'numdoc',
      key: 'numdoc',
      align: "center",
      sorter: (a, b) => {
        if (!a.numdoc && b.numdoc) return 1;
        if (a.numdoc && !b.numdoc) return -1;
        if (!a.numdoc && !b.numdoc) return 0;
        return a.numdoc.localeCompare(b.numdoc);
      },
    },
    {
      title: 'Date bon',
      dataIndex: 'datedoc',
      key: 'datedoc',
      align: "center",
      sorter: (a, b) => {
        const dateA = a.datedoc ? moment(a.datedoc).unix() : 0;
        const dateB = b.datedoc ? moment(b.datedoc).unix() : 0;
        return dateA - dateB;
      },
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", paddingLeft: "5px", paddingRight: "5px" }}>
          {text ? moment(text).locale("fr").format("DD/MM/YYYY") : "N/A"}
        </div>
      ),
    },
    {
      title: 'Frais réels',
      dataIndex: 'montdoc',
      key: 'montdoc',
      align: "right",
      sorter: (a, b) => (a.montdoc ?? 0) - (b.montdoc ?? 0),
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
          {text && parseFloat(text) !== 0 ? parseFloat(text).toLocaleString() : ""}
          </strong>
        </div>
      ),
    },
    {
      title: 'QP Part.',
      dataIndex: 'ticket',
      key: 'ticket',
      align: "right",
      sorter: (a, b) => (a.ticket ?? 0) - (b.ticket ?? 0),
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
          {text && parseFloat(text) !== 0 ? parseFloat(text).toLocaleString() : ""}
          </strong>
        </div>
      ),
    },
    {
      title: 'Date prochaine',
      dataIndex: 'dateres',
      key: 'dateres',
      align: "center",
      sorter: (a, b) => {
        const dateA = a.dateres ? moment(a.dateres).unix() : 0;
        const dateB = b.dateres ? moment(b.dateres).unix() : 0;
        return dateA - dateB;
      },
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", paddingLeft: "5px", paddingRight: "5px" }}>
          {text ? moment(text).locale("fr").format("DD/MM/YYYY") : "N/A"}
        </div>
      ),
    },
    {
      title: 'J. restants',
      dataIndex: 'nbjours',
      key: 'nbjours',
      align: "center",
      sorter: (a, b) => (a.nbjours ?? 0) - (b.nbjours ?? 0),
    },
    {
      title: 'Fournisseur',
      dataIndex: 'raisoc',
      key: 'raisoc',
      sorter: (a, b) => {
        if (!a.raisoc && b.raisoc) return 1;
        if (a.raisoc && !b.raisoc) return -1;
        if (!a.raisoc && !b.raisoc) return 0;
        return a.raisoc.localeCompare(b.raisoc);
      },
    },
  ];
  
  const handleRefresh = async () => {
    setLoading(true);
    try {
     
        const data = await suspensionsService.getSuspensionsOpt();
        setTableData(data);
        setFilteredData(data);
     
    } catch (error) {
      console.error("Erreur lors de l'actualisation des données :", error);
    } finally {
      setLoading(false);
    }
  };

  const isTableEmpty = filteredData.length === 0;

  return (
    <div>
      <Row gutter={16} style={{marginBottom: 16 }}>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={8}
          style={{ display: "flex", justifyContent: "start"}}
        >
          <Space wrap>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <Input
                placeholder="Recherche..."
                bordered={false}
                style={{ borderBottom: "2px solid black", width: "100%" }}
                onChange={(e) => handleSearch(e.target.value)}
                onPressEnter={(e) => handleSearch(e.target.value)}
              />
            </Space>
          </Space>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={16}
          style={{ display: "flex", justifyContent: "end", alignItems: "end" }}
        >
          <Flex wrap="wrap" gap="small">
            <Button
              className="buttonExport"
              disabled={isTableEmpty}
              onClick={() => exportToExcel(filteredData)}
            >
              Export Excel
            </Button>
            <Button
              icon={<SyncOutlined />}
              className="buttonRefresh"
              onClick={handleRefresh}
              loading={loading} // Affiche une animation de chargement sur le bouton
            >
              Actualiser
            </Button>
          </Flex>
        </Col>
      </Row>

      <Table
        scroll={{ x: true }}
        style={{
          cursor: "pointer",
          whiteSpace: "nowrap",
          width: "100%",
        }}
        className="custom-header2-table"
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          current: currentPage,
          total: filteredData.length,
          onChange: (page) => setCurrentPage(page),
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        bordered
        showSorterTooltip={false}
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey={record => record.numdoc}
        title={() => (
          <>
            <Space>
              <strong> Frais rééls: {totalMontdoc.toLocaleString()}</strong> 
              <strong> - QP Part.: {totalTicket.toLocaleString()}</strong> 
            </Space>
            
          </>
        )}
      />
    </div>
  );
};

export default SuspensionsOpt;
